var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAurora(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2215,
    height: 2500,
    viewBox: "0 0 256 289",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 224.742l29.972 35.125 2.695-3.201V32l-2.695-3.395L0 63.717v161.025",
    fill: "#1A476F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.976 259.867l57.27 28.633 2.382-3.833L89.667 3l-2.381-3-57.31 28.541v231.326",
    fill: "#1F5B98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256 63.717l-29.98-35.112-3.353 1.062.666 227.333 2.687 2.867L256 224.746V63.717",
    fill: "#2D72B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.75 288.5l57.27-28.633V28.541L168.71 0 166 3.667l.039 280.666 2.711 4.167",
    fill: "#5294CF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.286 0h81.424v288.504H87.286V0z",
    fill: "#2D72B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAurora);
export default __webpack_public_path__ + "static/media/aurora.f694c488590978fdbd73a4d669a50dd4.svg";
export { ForwardRef as ReactComponent };